<p-dialog
  header="{{ config[refType]?.header | translate }}"
  [modal]="true"
  [(visible)]="popupVisible"
  [style]="{ width: '40rem' }"
  class="create-branch-popup"
  (onShow)="onDialogShow()"
  (onHide)="onReset()"
  [draggable]="false"
>
  <form [formGroup]="branchForm">
    <div class="form-group mb-1 mt-1">
      <label class="col-sm-4 col-form-label" for="sourceBranch">{{ 'SOURCE_BRANCH' | translate }}</label>
      <div class="col-sm-8">
        <input pInputText id="sourceBranch" formControlName="sourceBranch" [disabled]="true" />
        <div class="warning-message" *ngIf="showUnpublishedWarningMessage">
          {{ 'BRANCH_HAS_UNPUBLISHED_CHANGES' | translate }}
          <i pTooltip="{{ 'UNPUBLISHED_CHANGES_TOOLTIP' | translate }}" tooltipPosition="top"
            class="pi pi-exclamation-circle ml-1"></i>
        </div>
        </div>
    </div>

    <div class="form-group mb-1">
      <label class="col-sm-4 col-form-label" for="refName">{{ config[refType]?.nameFieldLabel | translate }}</label>
      <div class="col-sm-8">
        <input
          #refNameInput
          pInputText
          id="refName"
          formControlName="refName"
          autocomplete="off"
          [ngClass]="{ 'error-border': shouldShowError('refName') }"
        />
        <small
          class="input-error-text"
          *ngIf="shouldShowError('refName')"
        >
          <span>{{ branchForm.get('refName')?.errors?.gitNameError.replace('name', config[refType]?.nameFieldLabel | translate) }}</span>
        </small>
      </div>
    </div>
    <div class="form-group mb-1">
      <label class="col-sm-4 col-form-label" for="gitRefName">{{ config[refType]?.gitNameFieldLabel | translate }}</label>
      <div class="col-sm-8">
        <input
          pInputText
          id="gitRefName"
          formControlName="gitRefName"
          autocomplete="off"
          [ngClass]="{ 'error-border': shouldShowError('gitRefName') }"
        />
        <small
          class="input-error-text"
          *ngIf="shouldShowError('gitRefName')"
        >
          <span>{{ branchForm.get('gitRefName')?.errors?.gitNameError.replace('name', config[refType]?.gitNameFieldLabel | translate) }}</span>
        </small>
      </div>
    </div>

    <div class="button-group mt-2 mb-2">
      <p-button label="{{ 'CANCEL' | translate }}" class="cancel-btn" (click)="onReset()" (keydown.enter)="onReset()"></p-button>
      <p-button label="{{ 'SAVE' | translate }}" class="save-btn" (click)="onSave()" (keydown.enter)="onSave()"></p-button>
    </div>
  </form>
</p-dialog>

<div class="card justify-center">
  <p-dialog
    header="{{ config[refType]?.inProgressSpinnerHeader | translate }}"
    [modal]="true"
    [(visible)]="isSpinnerVisible"
    [closable]="false"
    [style]="{ width: '40rem' }"
    [draggable]="false"
  >
    <div class="mt-2 branch-spinner-container">
      <i class="pi pi-spin pi-spinner"></i>
      <p class="p-text-secondary text-center">
        {{ spinnerMessage }}
      </p>
    </div>
  </p-dialog>
</div>

<div class="card justify-center">
  <p-dialog
    header="{{ config[refType]?.refCreationStatus | translate }}"
    [modal]="true"
    [(visible)]="showSuccessDialog"
    [closable]="false"
    [style]="{ width: '40rem' }"
    [draggable]="false"
  >
    <div class="mt-2 branch-spinner-container">
      <p>{{ messageFromResponse }}</p>
      <p class="mt-2 mb-0">
        <a [href]="targetUrlForNavigation" target="_blank" *ngIf="targetUrlForNavigation">
          {{ 'GO_TO_TARGET_BRANCH' | translate }}
          <i class="pi pi-external-link ml-1"></i>
        </a>
      </p>
    </div>
    <ng-template pTemplate="footer">
      <p-button label="{{ 'OK' | translate }}" (click)="closeSuccessDialog()" (keydown.enter)="closeSuccessDialog()"></p-button>
    </ng-template>
  </p-dialog>
</div>

